export function makeMrqDashboardUrl(id) {
  return `${process.env.REACT_APP_MRQ_DASHBOARD_BASE_URL}/#jobs?id=${id}`;
}

export function makeLabelingTrackerUrl(id) {
  return `${process.env.REACT_APP_LABELING_TRACKER_BASE_URL}/mission/${id}`;
}
